import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function ComingSoon() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Orbitron', color: 'var(--theme-primary)' }}>
          {t('common.comingSoon')}
        </h1>
        <p className="text-gray-400 mb-6">{t('common.comingSoonDesc')}</p>
        <button onClick={() => navigate('/')} className="px-6 py-3 rounded-lg font-bold transition-all" style={{ background: 'var(--theme-primary)', color: 'white' }}>
          {t('common.back')}
        </button>
      </motion.div>
    </div>
  );
}
